// src/pages/Home.jsx
import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Offers from '../components/Offers';
import Testimonials from '../components/Testimonials';
import BlogSection from '../components/BlogSection';

function Home() {
  return (
    <div>
      <Hero />
      <About />
      <Offers />
      <BlogSection />
    </div>
  );
}

export default Home;